import { IButtonProps, IconName } from '@amobee/component-library';
import { Component, OnInit, Input } from '@angular/core';

export interface IFooterProp extends IButtonProps {
  isActive?: () => boolean,
  isDisabled?: () => boolean,
  showIcon?: () => IconName
};

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() buttons: Array<IButtonProps>;

  constructor() {
  }

  ngOnInit() { }

}
